import * as React from 'react';
import { useState } from 'react';
import { Parallax } from 'react-scroll-parallax';

import MagnifyingGlassIcon from './assets/magnifying-glass.inline.svg';
import PlusIcon from './assets/plus.inline.svg';
import InfoGraphic1 from './assets/infographic1.inline.svg';
import InfoGraphic1Mob from './assets/infographic1.mob.inline.svg';
import InfoGraphic2 from './assets/infographic2.inline.svg';
import InfoGraphic2Mob from './assets/infographic2.mob.inline.svg';
import InfoGraphic3 from './assets/infographic3.inline.svg';
import InfoGraphic3Mob from './assets/infographic3.mob.inline.svg';
import InfoGraphic4 from './assets/infographic4.inline.svg';
import InfoGraphic4Mob from './assets/infographic4.mob.inline.svg';

import './style.scss';

const ImprovementProgramInfoGraphicsSection = () => {
  const [toggleInfographic3, setToggleInfographic3] = useState(false);

  return (
    <section className="l-improvement-program-infographics-section">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
        <div className="bg2" />
      </Parallax>

      <div className="container">
        <h2 className="section-title">Professional Standard Improvement Program</h2>
        <div className="grid">
          <div
            className="card infographic1"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="infographic">
              <InfoGraphic1 />
              <InfoGraphic1Mob />
            </div>
          </div>

          <div
            className="card infographic2"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="infographic">
              <InfoGraphic2 />
              <InfoGraphic2Mob />
            </div>
          </div>

          <div
            className="card infographic3"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div
              role="button"
              tabIndex={0}
              className="graphic"
              onClick={() => setToggleInfographic3(!toggleInfographic3)}
              onKeyDown={() => setToggleInfographic3(!toggleInfographic3)}
              aria-label="Toggle between 2019 causes and 2020 causes"
            >
              <div className={`toggle ${!toggleInfographic3 ? 'is-active' : ''}`}>
                <PlusIcon />
              </div>
              <div className={`infographic ${!toggleInfographic3 ? 'is-2019' : 'is-2020'}`}>
                <InfoGraphic3 />
                <InfoGraphic3Mob />
              </div>
              <div className={`toggle ${toggleInfographic3 ? 'is-active' : ''}`}>
                <PlusIcon />
              </div>
            </div>
            <div className={`content ${toggleInfographic3 ? 'is-arrow-btm' : ''}`}>
              {!toggleInfographic3 ? (
                <>
                  <div className="title">
                    <MagnifyingGlassIcon />
                    Causes
                  </div>
                  <ol>
                    <li>Negligence – Communication / advice / administration </li>
                    <li>Misappropriation, misleading and deceptive</li>
                    <li>Lack of skill and competence</li>
                  </ol>
                </>
              ) : (
                <>
                  <div className="title">
                    <MagnifyingGlassIcon />
                    Causes
                  </div>
                  <ol>
                    <li>Negligence – Communication / advice / administration</li>
                    <li>Technical issues</li>
                    <li>Lack of skill and competence</li>
                  </ol>
                </>
              )}
            </div>
          </div>

          <div
            className="card infographic4"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <div className="infographic">
              <InfoGraphic4 />
              <InfoGraphic4Mob />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImprovementProgramInfoGraphicsSection;
